/**
 * The character budgets the tool surface is written against.
 *
 * These are the published WebMCP limits, not house style, which is why they are
 * constants read by the catalogue tests now and by `validateCatalogue` in task
 * 3.5 rather than numbers repeated at each check. Requirements 11.1, 11.2 and
 * 11.3 name them one for one.
 */

/** Tool names and parameter names. Req 11.1. */
export const MAX_NAME_CHARS = 30;

/** Tool descriptions. Req 11.2. */
export const MAX_DESCRIPTION_CHARS = 500;

/** Parameter descriptions. Req 11.2. */
export const MAX_PARAM_DESCRIPTION_CHARS = 150;

/**
 * Tool output. Req 11.3.
 *
 * Enforced in the registration wrapper (task 3.7) rather than in a verb, so no
 * verb can forget: past this length the wrapper truncates at a sentence boundary
 * and appends a hint naming the verb that returns the remainder.
 */
export const MAX_OUTPUT_CHARS = 1500;
